@if (currentlySelectedFile(); as file) {
  <div class="d-flex align-items-center justify-content-between gap-2 mx-1 my-2">
    <div class="d-flex align-items-center gap-2">
      <em aria-hidden="true" class="pi pi-file"></em>
      <span class="bold">{{ file.name }}</span>
    </div>
    <span class="text-muted ms-2">({{ file.size | localizedByteFormat }})</span>

    <p-button icon="pi pi-times" size="small" (onClick)="removeFile()" [rounded]="true"></p-button>
  </div>
}

<div>
  <input type="file" id="fileInput" #fileInput hidden (change)="onFileSelected($event)" />
  <label for="fileInput" hidden>{{ 'pages.transport.upload-dialog.buttons.select-file' | translate }}</label>

  <div class="select-file__button-wrapper">
    <p-button
      icon="pi pi-upload"
      variant="text"
      (onClick)="fileInput.click()"
      [label]="'pages.transport.upload-dialog.buttons.select-file' | translate"
    ></p-button>

    @if (currentlySelectedFile()) {
      <p-button icon="pi pi-times" variant="text" (onClick)="removeFile()" [label]="'general.cancel' | translate"></p-button>
    }
  </div>
</div>
